(function (global) {
  'use strict';

  function normalizeDigits(value) {
    return String(value == null ? '' : value)
      .replace(/[٠-٩]/g, function (digit) { return String(digit.charCodeAt(0) - 0x0660); })
      .replace(/[۰-۹]/g, function (digit) { return String(digit.charCodeAt(0) - 0x06f0); });
  }

  function normalizePhoneInput(value) {
    return normalizeDigits(value).replace(/[^0-9+\s().-]/g, '');
  }

  function normalizeOtpInput(value, maxLength) {
    return normalizeDigits(value).replace(/[^0-9]/g, '').slice(0, maxLength || 6);
  }

  function firstLetter(value, fallback) {
    var characters = Array.from(String(value || '').normalize('NFC'));
    var letter = characters.find(function (character) {
      return character !== '\u0640' && /\p{L}/u.test(character);
    });
    return letter ? letter.toLocaleUpperCase() : (fallback || 'R');
  }

  function normalizeField(field, type) {
    if (!field) return '';
    var normalized = type === 'otp'
      ? normalizeOtpInput(field.value, Number(field.getAttribute('maxlength')) || 6)
      : normalizePhoneInput(field.value);
    if (field.value !== normalized) field.value = normalized;
    return normalized;
  }

  function bindField(field, type) {
    if (!field || field.dataset.rwDigitsBound === 'true') return;
    field.dataset.rwDigitsBound = 'true';
    field.style.direction = 'ltr';
    field.addEventListener('input', function () { normalizeField(field, type); });
    field.addEventListener('paste', function () {
      global.setTimeout(function () { normalizeField(field, type); }, 0);
    });
    normalizeField(field, type);
  }

  function bindAll(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-rw-digit-input]').forEach(function (field) {
      bindField(field, field.dataset.rwDigitInput);
    });
  }

  global.RwadyInputUtils = {
    normalizeDigits: normalizeDigits,
    normalizePhoneInput: normalizePhoneInput,
    normalizeOtpInput: normalizeOtpInput,
    normalizeField: normalizeField,
    bindField: bindField,
    bindAll: bindAll,
    firstLetter: firstLetter
  };

  if (global.document) {
    if (global.document.readyState === 'loading') {
      global.document.addEventListener('DOMContentLoaded', function () { bindAll(global.document); });
    } else bindAll(global.document);
    global.document.addEventListener('shopify:section:load', function (event) { bindAll(event.target); });
  }
})(typeof window !== 'undefined' ? window : globalThis);
